import adminRoute from './admin/route'
import organizationsRoute from '@/views/organizations/route'
import assignmentFormRoute from './assignmentForm/route'
import oldRoutingRedirects from '../utils/oldRoutingRedirects'
import coursesRoute from '@/views/courses/route'
import assignmentsRoute from '@/views/assignments/route'
import sectionsRoute from '@/views/sections/route'
import sessionsRoute from '@/views/sessions/route'
import popupsRoute from '@/views/popups/route'
import noteBoardsRoute from '@/views/noteBoards/route'
import learnicsURoute from '@/views/u/route'
import noteBoardRoute from '@/views/noteBoard/route'
import studentReportRoute from '@/views/studentReport/route'

function lazyLoad(view) {
  return () => import(`./${view}.vue`)
}
export default [
  ...oldRoutingRedirects,
  studentReportRoute,
  noteBoardsRoute,
  noteBoardRoute,
  learnicsURoute,
  popupsRoute,
  assignmentFormRoute,
  adminRoute,
  {
    path: '/login',
    name: 'LoginView',
    component: lazyLoad('LoginView'),
  },
  {
    path: '/studentLogout',
    name: 'StudentLogoutPortal',
    component: lazyLoad('StudentLogoutPortal'),
  },
  {
    path: '/teacher-try-for-free',
    name: 'TeacherTryForFreePortal',
    props: true,
    component: lazyLoad('TeacherTryForFreePortal'),
  },
  {
    path: '/teacher-try-for-free-redirect',
    name: 'TeacherTryForFreeRedirectPortal',
    props: true,
    component: lazyLoad('TeacherTryForFreeRedirectPortal'),
  },
  {
    path: '/extensionLogout',
    name: 'ExtensionLogoutPortal',
    component: lazyLoad('ExtensionLogoutPortal'),
  },
  {
    path: '/localHostAuth',
    name: 'LocalHostAuthPortal',
    component: lazyLoad('LocalHostAuthPortal'),
  },
  {
    path: '/extensionUninstallSuccess',
    name: 'ExtensionUninstallSuccessView',
    component: lazyLoad('ExtensionUninstallSuccessView'),
  },
  {
    path: '/driveFileSelect',
    name: 'DriveFileSelectView',
    component: lazyLoad('DriveFileSelectView'),
  },
  {
    path: '/studentLogin',
    name: 'StudentLoginView',
    component: lazyLoad('StudentLoginView'),
  },
  {
    path: '/customTokenLogin',
    name: 'CustomTokenLoginPortal',
    component: lazyLoad('CustomTokenLoginPortal'),
  },
  {
    path: '/oauth2Login',
    name: 'Oauth2LoginView',
    component: lazyLoad('Oauth2LoginView'),
  },
  {
    path: '/oauth2LoginWarning',
    name: 'Oauth2LoginWarningView',
    component: lazyLoad('Oauth2LoginWarningView'),
  },
  {
    path: '/oauth2Callback',
    name: 'Oauth2CallbackView',
    component: lazyLoad('Oauth2CallbackView'),
  },
  {
    path: '/respondToAccessRequest/:accessRequestId',
    name: 'RespondToAccessRequestView',
    component: lazyLoad('RespondToAccessRequestView'),
    props: true,
  },

  {
    path: '/noteBoardShare/:noteBoardId/:shareId',
    props: true,
    component: lazyLoad('NoteBoardShareView'),
  },
  {
    path: '/start',
    name: 'IndependentStartView',
    component: lazyLoad('IndependentStartView'),
  },

  {
    path: '/acceptInvitation/:invitationId',
    name: 'AcceptInvitationPortal',
    component: lazyLoad('AcceptInvitationPortal'),
    props: true,
  },
  // Note order matters here and paths above this / route are checked first.  This / path
  // and its children will not be considered if a path declared above it is matched.
  // Paths declared below it will all be consumed by the final * route of /.
  {
    path: '/',
    component: lazyLoad('AppRoot'),
    children: [
      { path: '', redirect: './organizations' },
      organizationsRoute,
      coursesRoute,
      assignmentsRoute,
      sessionsRoute,
      sectionsRoute,
      {
        path: 'logout',
        name: 'LogoutPortal',
        component: lazyLoad('LogoutPortal'),
      },
      {
        path: 'enrollStudent/:assignmentId',
        name: 'EnrollStudentView',
        component: lazyLoad('EnrollStudentView'),
        props: true,
      },
      {
        path: 'assignment/:access_code',
        name: 'AssignmentAccessCodePortal',
        component: lazyLoad('AssignmentAccessCodePortal'),
      },
      {
        path: 'newTeacher',
        name: 'NewTeacherView',
        component: lazyLoad('NewTeacherView'),
        props: true,
      },
      {
        path: 'newUser',
        name: 'NewUserView',
        component: lazyLoad('NewUserView'),
        props: true,
      },
      {
        path: 'newStudent',
        name: 'NewStudentView',
        component: lazyLoad('NewStudentView'),
        props: true,
      },
      {
        path: 'registerPlatform',
        name: 'registerPlatform',
        component: lazyLoad('RegisterPlatformView'),
      },
      {
        name: 'PageNotFoundView',
        path: '*',
        component: lazyLoad('PageNotFoundView'),
      },
    ],
  },
]
